import { Box, Stack, Typography, styled } from '@mui/material'

export const StyledStack = styled(Stack)({
  alignItems: 'center',
  justifyContent: 'space-between',
})

export const StyledBoxCard = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(500px, 1fr))',
  gap: '1rem',
})
export const StyledBoxContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '10px 0',
})

export const StyledTypography = styled(Typography)({
  pl: '2px',
  pt: '6px',
  variant: 'caption',

  color: 'rgb(211, 47, 47)',
})
